<template>
  <v-card>
    <v-toolbar
      dense
    >
      Navigation
      <v-spacer />
      <v-btn
        color="red"
        dark
        @click="$emit('dismiss')"
      >Close</v-btn>
    </v-toolbar>
    <v-card-text>
      <scrollactive
        v-on:itemchanged="onItemChanged"
      >
        <div style="padding-right:10px;">
          <div
            v-for="section in sectionHeads"
            :key="section.id"
            style="text-indent: -42px;padding-left:40px;"
          >
            <a
              :href="sectionElSelector(section)"
              class="scrollactive-item"
              @click="$emit('dismiss')"
            >
              <span v-if="section.number">{{ section.number }}.</span>
              {{ section.text }}
            </a>
          </div>
        </div>
      </scrollactive>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'UserFormNavigator',
  props: [ 'userform' ],
  computed: {
    sectionHeads () {
      return this.userform.sections.filter(section => section.part_type === "s")
    }
  },
  methods: {
    sectionElSelector (section) {
      return `#section-${section.id}`
    },
    onItemChanged(event, currentItem) {
      try {
        history.replaceState(null, null, '#' + currentItem.href.split('#')[1])
      } catch (e) {
        // do nothing
      }
    }
  }
}
</script>

<style scoped>
a {
  text-decoration: none;
  color: grey;
  margin:5px;
  padding-left: 16px;
  line-height: 25px;
}

a:hover {
  text-decoration: underline;
}

a.is-active {
  font-weight: bold;
  color:#2196f3!important;
  position:relative;
  border-left: solid #2196f3 2px;
}
</style>
